const firebaseConfig = {
    apiKey: "AIzaSyCemdojog_qiEacjFau6tukwwraVWY7ZF4",
    authDomain: "node-mongo-assignment11.firebaseapp.com",
    projectId: "node-mongo-assignment11",
    storageBucket: "node-mongo-assignment11.appspot.com",
    messagingSenderId: "591586940871",
    appId: "1:591586940871:web:7b306d18ec58e53d4f6be2"
};

export default firebaseConfig;